import { QueryClient, UseMutationResult } from 'react-query';
import { getOrgSettingsApi, updateOrgSettingsApi } from '../constants/apiEndPoints';
import HttpServiceHelper from './httpServiceHelper';
import { _HttpMethods, _Payload } from '../constants/staticTypes';
import { AxiosResponse } from 'axios';
import { getErrorMessage } from '../utils/common';
import { AlertVariant } from '../constants/constants';

export const getOrgSettings = (queryClient: QueryClient, xTenantId?: string) => {
    let url = `${getOrgSettingsApi}`;

    return HttpServiceHelper({
        url,
        method: _HttpMethods.POST,
        queryClient,
        data: {
            id: localStorage.getItem('X-Organization-Id'),
        },
    });
};

export type _UpdateSettingsData = {
    id?: string;
    webLogo: string | null;
    mobileLogo: string | null;
    primaryColor: string;
    secondaryColor: string;
};

export const updateOrgSettings = (
    addAdminOrgPermissionMutation: UseMutationResult<AxiosResponse<any, any>, unknown, _Payload, unknown>,
    param: _UpdateSettingsData,
    onSuccess: (data: any) => void,
    onError: (res: string, variant: string) => void
) => {
    addAdminOrgPermissionMutation.mutate(
        {
            url: updateOrgSettingsApi,
            method: _HttpMethods.PUT,
            data: param,
        },
        {
            onSuccess: (res) => onSuccess(res.data),
            onError: (res) => onError(getErrorMessage(res), AlertVariant.ERROR),
        }
    );
};
